"use client"
import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import MapPointContent from "@/components/maps/MapPointContent";
import EmbeddedMapContent from "@/components/maps/EmbeddedMapContent";
import EmbeddedProfileContent from "@/components/maps/embed/EmbeddedProfileContent";
import EmbeddedEventContent from "@/components/maps/embed/EmbeddedEventContent";
import EmbeddedPostContent from "@/components/posts/EmbeddedPostContent";

const EmbeddedPointCard = ({
  name,
  coordinates,
  external,
  community,
  point,
  contentId,
  ownerId,
  enableEdit
}) => {
  const [cardContent, setCardContent] = useState(null);
  const [cardId, setCardId] = useState(null);

  useEffect(() => {
    if (point) {
      buildCardContent(point);
      setCardId(point.id);
    }
  }, [point]);

  const buildCardContent = mapPoint => {
    // console.log("EmbeddedPointCard buildCardContent", mapPoint, enableEdit);
    var content;
    if (mapPoint.type === "POINT") {
      content = (
        <MapPointContent
          showTitle={true}
          point={mapPoint}
          ownerId={ownerId}
          mapId={contentId}
          coordinates={coordinates}
          external={external}
          community={community}
        />
      );
    } else if (mapPoint.type === "STORY") {
      content = (
        <EmbeddedMapContent
          mapView={mapPoint.story}
          coordinates={coordinates}
          showTitle={true}
          external={external}
          community={community}
        />
      );
    } else if (mapPoint.type === "EVENT") {
      content = (
        <EmbeddedEventContent
          event={mapPoint.event}
          showTitle={true}
          coordinates={coordinates}
          external={external}
          community={community}
        />
      );
    } else if (mapPoint.type === "POST") {
      content = (
        <EmbeddedPostContent
          post={mapPoint.post}
          showTitle={true}
          coordinates={coordinates}
          external={external}
          community={community}
        />
      );
    } else if (mapPoint.type === "USER_PROFILE") {
      // console.log("USER_PROFILE", mapPoint.userProfile);
      content = (
        <EmbeddedProfileContent
          name={name}
          profile={mapPoint.userProfile}
          coordinates={coordinates}
          external={external}
          community={community}
        />
      );
    } else if (mapPoint.type === "PROGRAM_MEMBER") {
      content = (
        <EmbeddedProfileContent
          name={name}
          profile={mapPoint.userProfile}
          coordinates={coordinates}
          external={external}
          community={community}
        />
      );
    }
    setCardContent(content);
  };

  return (
    <Card className="embedded-point-card">
      <Card.Body className="d-flex flex-column justify-content-start align-items-center p-0">
        <div className="content-marker-container" key={cardId}>
          {cardContent}
        </div>
      </Card.Body>
    </Card>
  );
};
export default EmbeddedPointCard;
